import React from 'react';
import { Header } from '../components/Header';
import { AngelikaSturnFooter } from '../components/AngelikaSturnFooter';
import { Link } from 'react-router-dom';
export function AngelikaSturnPage() {
  return <div className="min-h-screen bg-white" data-id="element-778">
      <Header data-id="element-779" />
      <main className="w-full pt-[152px]" data-id="element-780">
        <div className="w-full flex justify-center" data-id="element-781">
          <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-782">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rr1i8aApieSxbk4rXkWMLW/Header-Startseite-Angelika_Sturny.jpg" alt="Dr. Angelika Sturny" className="w-full h-full object-cover object-[70%_center]" data-id="element-783" />
            <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-784"></div>
            <div className="absolute inset-0 flex items-end pb-16 md:pb-40" data-id="element-785">
              <div className="max-w-5xl w-full mx-auto px-6 md:px-12" data-id="element-786">
                <div className="max-w-lg text-left" data-id="element-787">
                  <blockquote className="text-white text-2xl md:text-3xl font-light italic mb-4" data-id="element-788">
                    „Empathie beginnt mit dem Zuhören."
                  </blockquote>
                  <p className="text-white text-xl" data-id="element-789">– Carl Rogers</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto py-16 px-6 md:px-12" data-id="element-790">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-791">
            Herzlich willkommen
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-792">
            auf der Webseite meiner Privatpraxis für Psychotherapie, Coaching,
            Paar- und Familientherapie in München.
          </p>
          <div className="text-lg text-gray-600 leading-relaxed space-y-6 mb-12" data-id="element-793">
            <p data-id="element-794">
              Das Leben stellt uns immer wieder vor Herausforderungen, die uns
              emotional belasten, unsere Kräfte erschöpfen oder unsere
              Orientierung infrage stellen. In solchen Momenten kann eine
              professionelle Begleitung durch Beratung oder Psychotherapie
              wertvolle Unterstützung bieten.
            </p>
            <p data-id="element-795">
              <span className="font-semibold" data-id="element-796">
                In meiner Praxis begleite ich Einzelpersonen, Paare, Familien,
                Kinder und Jugendliche in herausfordernden Zeiten
              </span>{' '}
              – bei Krisen, Konflikten oder wenn berufliche und private
              Belastungen das System aus dem Gleichgewicht bringen. In meiner
              Praxis finden Sie professionelle Unterstützung, Orientierung und
              Raum für Entwicklung.
            </p>
            <p data-id="element-797">
              Mein Ansatz basiert auf der systemischen Therapie sowie meiner
              langjährigen Erfahrung im Umgang mit Menschen in beruflichen und
              privaten Belastungssituationen.
            </p>
            <p data-id="element-798">
              Dies ermöglicht mir, fundiert, zielorientiert und zugleich
              wertschätzend auf Ihre Themen einzugehen.
            </p>
            <p data-id="element-799">
              <Link to="/angelika_sturny/psychotherapie" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-800">
                Hier finden Sie alle Informationen
              </Link>{' '}
              zu meinem Ansatz, meinem Angebot und dem Ablauf der
              Zusammenarbeit.
            </p>
            <p data-id="element-801">Ich freue mich darauf, Sie kennenzulernen.</p>
          </div>
          <div className="mb-12" data-id="element-802">
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-803">
              Mein Ziel:
            </h2>
            <div className="bg-[#cda8be] p-8 rounded-lg border-l-4 border-white" data-id="element-804">
              <p className="text-lg font-light text-white leading-relaxed" data-id="element-805">
                "Verstehen ist der erste Schritt der Veränderung. In einem
                geschützten Raum erkunden wir gemeinsam festgefahrene Muster und
                entdecken neue, stimmige Wege – für mehr Leichtigkeit,
                Verbindung und Lebendigkeit"
              </p>
            </div>
          </div>
          <div className="mb-12" data-id="element-806">
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-807">
              Mein Angebot
            </h2>
            <ul className="space-y-3 text-lg text-gray-600" data-id="element-808">
              <li className="flex items-start" data-id="element-809">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-810"></div>
                <span data-id="element-811">Individuelle Psychotherapie</span>
              </li>
              <li className="flex items-start" data-id="element-812">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-813"></div>
                <span data-id="element-814">Individuelles Coaching</span>
              </li>
              <li className="flex items-start" data-id="element-815">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-816"></div>
                <span data-id="element-817">Systemische Paarberatung</span>
              </li>
              <li className="flex items-start" data-id="element-818">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-819"></div>
                <span data-id="element-820">Systemische Familientherapie</span>
              </li>
              <li className="flex items-start" data-id="element-821">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-822"></div>
                <span data-id="element-823">
                  Beratung und Familientherapie für Kinder und Jugendliche
                </span>
              </li>
            </ul>
          </div>
          <div className="mt-8 text-center" data-id="element-824">
            <p className="text-gray-600 mb-4" data-id="element-825">
              Die Rahmenbedingungen wie Terminvereinbarung, Ablauf und Kosten
              finden Sie unter{' '}
              <Link to="/angelika_sturny/info" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-826">
                Info
              </Link>
              .
            </p>
            <p className="text-gray-600" data-id="element-827">
              Appointments are also possible in English. Please contact me via{' '}
              <a href="mailto:praxis@angelikasturny.com" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-828">
                email
              </a>{' '}
              for sessions in English!
            </p>
          </div>
        </div>
      </main>
      <AngelikaSturnFooter data-id="element-829" />
    </div>;
}